import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { Routes } from "@angular/router";

import SwiperCore, { Navigation, Pagination } from 'swiper';


import { LocalizationModule, SharedModule } from 'src/core/index/shared.module.index';
import { AuthGuard } from "src/index/services.index";
import { TeacherProfileComponent } from "./teacher-profile/teacher-profile.component";

SwiperCore.use([Navigation, Pagination]);

const routes: Routes = [ // Rotte definite ma RoutingModule non configurato, per poter gestire eventuale override da app esterna
    {
        path: 'teacher/:id',
        canActivate: [AuthGuard],
        component: TeacherProfileComponent,
    }
];

@NgModule({
    declarations: [
        TeacherProfileComponent,
    ],
    imports: [
        CommonModule,
        LocalizationModule,
        SharedModule,
    ],
    providers: [
        AuthGuard,
    ],
    exports: [
        TeacherProfileComponent,
    ],
})
export class TeachersModule {
    getRoutes() {
        return routes;
    }
}
